export default __webpack_public_path__ + "static/tour-use-dont-87dc4c89a131a00453ed94982cbe24d1fee8ba35e5f000464a164aac2d78083c.png";